import { BabylonState } from "../../state";

import { reloadStaleGrid } from "./reloadGrid";
import { reloadStalePaths } from "./reloadPaths";
import { reloadStalePositions } from "./reloadPositions";

/**
 * Schedules data loads for any components whose data has gone stale.
 */
export function reloadStaleComponents(state: BabylonState) {
  reloadStaleGrid(state);
  reloadStalePositions(state);
  reloadStalePaths(state);
}
